import { registerComponent } from '@gig/magic-common';
import EmailVerificationComponent from './email.vue.js';

var EmailVerification = registerComponent(EmailVerificationComponent);

export { EmailVerification };
